import { resourcesService } from "app/services";
import { useQuery } from "@tanstack/react-query";

export function useCamarasDeComercio() {
  const camarasDeComercio = useQuery({
    queryKey: ["camaras-de-comercio"],
    queryFn: resourcesService.getCamarasDeComercio,
  });

  return camarasDeComercio;
}
